import { uniqBy } from "lodash";

export const getUniqueObjectFromArray = (data, key) => {
    return uniqBy(data, key)
}

export const isLaunchedInIframeContainer = () => {
  return window.self !== window.top;
};
